import { render, staticRenderFns } from "./VActiveFormItem.vue?vue&type=template&id=500ea761"
import script from "./VActiveFormItem.vue?vue&type=script&lang=js"
export * from "./VActiveFormItem.vue?vue&type=script&lang=js"
import style0 from "./VActiveFormItem.vue?vue&type=style&index=0&id=500ea761&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports